import api from '@/api/user'

const user = {
  namespaced: true,
  state: {
    balance: 0,
    totalCost: 0, // unit: cent
    totalRentTime: 0, // unit: second
    couponAmount: 0, // unit: cent
    totalBonus: [], // 总可用的福利：时长卡 + 代金券
    allowCreateCourse: false
  },
  mutations: {
    SET_COST: (state, cost) => {
      state.balance = cost.balance
      state.totalCost = cost.amount
      state.totalRentTime = cost.timeSec
      state.couponAmount = isNaN(Number(cost.couponAmountYuan))
        ? 0
        : Number(cost.couponAmountYuan) * 100
      state.totalBonus = cost.totalBonus
    },
    SET_ALLOW_CREATE_COURSE: (state, data) => {
      state.allowCreateCourse = data
    }
  },
  actions: {
    async fetchAccount({ commit }) {
      const resData = await api.getAccount()
      if (resData.code === 0) {
        const {
          account: {
            balance,
            expense: { amount, timeSec },
            totalBonus
          },
          couponAmountYuan
        } = resData
        commit('SET_COST', {
          balance,
          amount,
          timeSec,
          couponAmountYuan,
          totalBonus
        })
      }
    },
    async getPrivilege({ commit }) {
      const res = await api.checkPrivilege(
        { type: 2 },
        { errMsg: '获取开课权限失败' }
      )
      if (res.code !== 0) {
        return
      }
      commit('SET_ALLOW_CREATE_COURSE', res.allowed)
    }
  }
}

export default user
